// Trend-annotation client (Olof: notes on peaks/dips — campaigns, payday weeks). Scoped to the
// viewed profile via ?manufacturer= (empty = whole market), exactly like the dos-layer calls; the
// HttpOnly session cookie carries auth, and the backend forces a supplier to its own scope.
import { TENANT } from '../tenant'

const API_BASE = import.meta.env.VITE_API_URL ?? ''

export interface Annotation {
  id: number
  scope: string
  date_from: string
  date_to: string
  note: string
  created_by: string | null
}

export interface AnnotationInput {
  date_from: string
  date_to?: string | null
  note: string
}

export async function fetchAnnotations(): Promise<Annotation[]> {
  const q = TENANT.manufacturer ? `?manufacturer=${encodeURIComponent(TENANT.manufacturer)}` : ''
  const r = await fetch(`${API_BASE}/api/annotations${q}`, { credentials: 'include' })
  if (!r.ok) throw new Error('Could not load the notes.')
  return (await r.json()).annotations as Annotation[]
}

export async function createAnnotation(body: AnnotationInput): Promise<Annotation> {
  const r = await fetch(`${API_BASE}/api/annotations`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...body, manufacturer: TENANT.manufacturer || null }),
  })
  if (!r.ok) {
    const detail = await r.json().then((d) => d.detail).catch(() => null)
    throw new Error(detail || 'Could not save the note.')
  }
  return (await r.json()) as Annotation
}

// Production's edge policy (Cloud Armor) refuses DELETE/PUT/PATCH, so deletions are POSTs.
export async function deleteAnnotation(id: number): Promise<void> {
  const r = await fetch(`${API_BASE}/api/annotations/${id}/delete`, {
    method: 'POST',
    credentials: 'include',
  })
  if (!r.ok) {
    const detail = await r.json().then((d) => d.detail).catch(() => null)
    throw new Error(detail || 'Could not delete the note.')
  }
}
